/* eslint-disable react/prop-types */
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { SiteFooter } from '@immediate_media/components';
import geti18NextConfig from '../../geti18NextConfig';

const Footer = (props) => {
  const { siteKey } = props;
  const i18NextConfig = geti18NextConfig(siteKey);

  // Remove unnecessary values for layout
  const layoutProps = Object.keys(props)
    .filter((key) => key !== 'siteKey')
    .reduce((acc, key) => {
      acc[key] = props[key];
      return acc;
    }, {});

  return (
    <I18nextProvider i18n={i18NextConfig}>
      <SiteFooter {...layoutProps} />
    </I18nextProvider>
  );
};

export default Footer;
